import { APP_URL } from '../config';
import { ChevronIcon } from '../components/Icons';

export default function Nav(): JSX.Element {
  return (
    <header className="sticky top-0 z-50 border-b border-border bg-bg/80 backdrop-blur">
      <nav className="container-page flex h-16 items-center justify-between">
        <a href="#top" className="flex items-center gap-2 font-semibold">
          <ChevronIcon className="h-7 w-7" />
          <span className="text-lg tracking-tight">Garage</span>
        </a>
        <div className="hidden items-center gap-7 text-sm text-muted md:flex">
          <a href="#features" className="hover:text-text">Features</a>
          <a href="#privacy" className="hover:text-text">Privacy</a>
          <a href="#pricing" className="hover:text-text">Pricing</a>
        </div>
        <a className="btn btn-primary" href={APP_URL}>
          Log in
        </a>
      </nav>
    </header>
  );
}
